kombi.sidebar = {
    collapseToggle: function() {
        let navItems = document.querySelectorAll('.sidebar .nav-item');
        navItems.forEach(item => {
            let isActive = item.querySelector('.nav-link').classList.contains('active');
            if (isActive) {
                let editImageBox = document.querySelector('.edit-image-box');
                if (item.classList.contains('profile-link')) {
                    editImageBox.classList.add('d-block');
                    editImageBox.classList.remove('d-none');
                }
            }
        });
    },
    menuLinkActive: function() {
        let menuLinks = document.querySelectorAll('.menu-links');
        menuLinks.forEach(link => {
            if(window.location.href == link.href) {
                link.classList.add('text-primary');
            }
        });
    },
    mobileDropdownModal: function() {
        let dropdownToggles = document.querySelectorAll('.nav-link.dropdown-toggle');

        if (dropdownToggles) {
            dropdownToggles.forEach(function(toggle) {
                toggle.addEventListener('click', function(event) {
                    if (window.innerWidth < 576) {
                        let dropdownMenu = this.closest('.nav-item').querySelector('.dropdown-menu');
                        let menuContent = dropdownMenu.innerHTML;
                        let menuTitle = toggle.textContent || toggle.innerText;

                        let modalBody = document.querySelector('#mobileDropdownModal .modal-body ul');
                        modalBody.innerHTML = menuContent;
                        let modalTitle = document.querySelector('#mobileDropdownModal .modal-title');
                        modalTitle.textContent = menuTitle.trim();

                        let modal = new bootstrap.Modal(document.getElementById('mobileDropdownModal'));
                        modal.show();
                    }
                });
            });
        }
    },
    navBarFade: function() {
        document.querySelectorAll('.fade-container').forEach(function(fadeContainer) {
            let fadeEnd = fadeContainer.querySelector('.fade-end');
            let fadeElement = fadeContainer.querySelector('.fade-element');
            
            function updateFadePosition() {
                let maxScrollLeft = fadeEnd.scrollWidth - fadeEnd.clientWidth;
                let currentScroll = fadeEnd.scrollLeft;
                let fadeWidth = 100; 
                if (currentScroll >= maxScrollLeft) {
                    fadeElement.style.display = 'none';
                } else {
                    fadeElement.style.display = '';
                    fadeElement.style.width = `${Math.min(fadeWidth, maxScrollLeft - currentScroll)}px`;
                }
            }
    
            fadeEnd.addEventListener('scroll', updateFadePosition);
    
            updateFadePosition();
        });
    }
}